import { render, staticRenderFns } from "./beddedPack.vue?vue&type=template&id=8c241f2e&scoped=true&"
import script from "./beddedPack.vue?vue&type=script&lang=js&"
export * from "./beddedPack.vue?vue&type=script&lang=js&"
import style0 from "./beddedPack.vue?vue&type=style&index=0&id=8c241f2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c241f2e",
  null
  
)

export default component.exports